'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { isHttpNotFound } from '@/lib/http-adapter';

// Only a 404 means the offering is genuinely gone, which is the case this
// redirect was written for. Every other failure keeps the customer where they
// are rather than bouncing them to a list page that is failing too. Returns the
// same answer the redirect acted on, so the caller can render nothing while the
// navigation runs.
export const useNotFoundRedirect = (error: unknown, listPath: string) => {
  const router = useRouter();
  const isGone = isHttpNotFound(error);

  useEffect(() => {
    if (isGone) {
      router.replace(listPath);
    }
  }, [isGone, listPath, router]);

  return isGone;
};
